// ESC Partindex app (external)

const {
    PartindexApp,
    components,
    lib,
    i18n,
    Vue
} = window._esc_Partindex

export {
    PartindexApp,
    components,
    lib,
    i18n,
    Vue
}

export function getGlobalInstance () {
    return window._esc_Partindex_instance
}

export function getGlobalConfig () {
    return window._esc_Partindex_config
}

/*
Reference:
declare global {
    interface Window {
        _esc_Partindex: {
            PartindexApp: Constructor<PartindexApp>;
            components: typeof components;
            lib: typeof lib;
            i18n: typeof i18n;
            Vue: typeof Vue;
        };
        _esc_Partindex_instance?: PartindexApp;

        _esc_GarageService: GarageService;
    }
}
*/



// WEBPACK FOOTER //
// ./src/resources/scripts/services/partindex.js